<template>
  <div class="filters-get">
    <ui-ui-button
      :disabled="!count && !loading"
      :type="!count && !loading ? 'neutral' : 'primary'"
      :resize="true"
      @click="!count && !loading ? null : $emit('get-filters')"
    >
      <FiltersFiltersGetText
        :loading="loading"
        :count="count"
        prefix="Показать"
      />
    </ui-ui-button>
  </div>
</template>

<script lang="ts">
import numWord from '~/common/num-word.js';

export default defineComponent({
  name: 'FiltersGetModal',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
  },
  methods: {
    wordEnd(count: number) {
      return numWord(count, ['Найдено', 'Найден', 'Найдено', 'Найдено'], false);
    },
  },
});
</script>

<style scoped lang="scss" src="./filters-get-modal-scss.scss" />
